export default "__VITE_ASSET__JN$ulBg7__"